import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function PageSEO({
  title,
  description,
  ogTitle,
  ogDescription,
  ogImage,
  slug
}) {
  const finalTitle = title
    ? (title.includes('KTS') ? title : `${title} - KTS-ENTREPRISE A/S`)
    : 'Entreprenør og kloak | Frederiksværk | KTS-Entreprise A/S';

  const finalDesc = description || 'KTS-Entreprise A/S, Entreprenør & Aut. kloakmester, i Frederiksværk. Mere end 30 års erfaring - Alt Kloak og Entreprenørarbejde udføres.';
  const finalOgTitle = ogTitle || finalTitle;
  const finalOgDesc = ogDescription || finalDesc;
  const finalOgImage = ogImage || 'https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-af6d0c462f414287a07066f34fda9d4b.jpg';
  const canonicalUrl = `https://www.kts-entreprise.dk${slug && slug !== 'index' ? `/${slug}` : ''}`;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDesc} />
      <meta property="og:image" content={finalOgImage} />
      <meta property="og:url" content={canonicalUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDesc} />
      <meta name="twitter:image" content={finalOgImage} />
    </Helmet>
  );
}
